export class FluVaccineUrl {
    public static get GET_FLU_BOOKING_INFO(): string { return '/api/Booking/fluBookingInfo/{id}'; }
    public static get GET_FLU_BOOKING_LIST(): string { return '/api/Booking/fluBookingList/{id}/{staffId}'; }
    public static get UPDATE_FLU_BOOKING(): string { return '/api/Booking/fluBooking'; }
    public static get GET_MEMBERS(): string { return '/api/Booking/{0}/members'; }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/flu-vaccine.url.ts